// @flow
import { selectRawProductsArray } from '@gandi/cart';

import type { FullState } from '../../../../types';

export const selectHasDomainWithIdn = (state: FullState): boolean =>
  selectRawProductsArray(state).some(
    product =>
      product.productType === 'domain' &&
      product.process === 'create' &&
      !!product.payload.lang,
  );
